export const agentsApi = {
    getAgents: 'v1/api/agents',
    createAgents: 'v1/api/agents',
    editAgents: 'v1/api/agents',
    deleteAgents: 'v1/api/agents',
    approveAgents: 'v1/api/agentAproval',
    resendInvite:"v1/api/agentAproval/resentInvite?Id=:userId",
    getAgentDoc: 'v1/api/agentDocUpload?agentId=',
    uploadAgentDoc: 'v1/api/agentDocUpload?agentId=',
    getAgentLogs: 'v1/api/agentAproval?agentId=:agentId',
    approveAgent: 'v1/api/approveAgent?payId=',
    agentBankDetails: 'v1/api/agents/approveAgentBankDetails?payId=',
    updateLabel: 'v1/api/agentDocUpload/updateLabel?label=:labelName&id=:fileId',
    getMouForAgents: 'v1/api/emailTemplates/emailTemplateSend?tenantId=:tenantId&eventTypeId=Email%2FPDF-MOU&agentId=:agentId',
    uniBlacklist: "v1/api/agents",
    getReports: 'v1/api/application/applicationReport',
    postAgentRating: 'v1/api/agents/rating',
    getAgentRating: 'v1/api/agents/rating?agentId=',
    getPaymentDetails: 'v1/api/payments/getPaymentDetails',
    getFineList:'v1/api/agents/getFineDetails?agentId=',
    updateFineAmount:'v1/api/agents/updateFineDetails?agentId=',
    addFineAmount:'v1/api/agents/addFineDetails?agentId=',
    getAgentPaymentDetails:'v1/api/payments/getPaidAgents',
    resetAgentPassword:'v1/api/agentAuth/resetPasswordFromAdmin',
    getReferrers:'v1/api/agents/getAllReferrers?skip=0&limit=100',
    getMarketingManager:'v1/api/users?jobRoleId=28&skip=0&limit=100',
    searchAgent:'v1/api/agents/superAdmin',
    sourceAgent:'v1/api/agents/getAllSources',
    addPartners: 'v1/api/partner',
    getPartners: 'v1/api/partner',
    getAccommodation: 'v1/api/amberInventories/partners/leads',
    getAccommodationEnquiryList: 'v1/api/accommodation',
    getLoanEnquiryList: 'v1/api/loan-enquiry',
}
